import React, { useEffect, useState } from 'react';
import { Spin, Modal } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import printIcon from '../../assets/print.png';
import './printSlide.css';
import { useReactToPrint } from 'react-to-print';
import PrintContainer from './printContainer';

const PrintSlide = () => {
    const [isPrinting, setIsPrinting] = useState(false);
    const [isGeneratingPreview, setIsGeneratingPreview] = useState(false);

    const handlePrint = () => {
        setIsPrinting(true);
        setIsGeneratingPreview(true);
        setTimeout(() => {
            setIsGeneratingPreview(false);
        }, 800);
    };

    const printSlides = useReactToPrint({
        content: () => document.getElementById("print-slide-container"),
        onAfterPrint: () => {
            setIsGeneratingPreview(false);
            setIsPrinting(false);
        }
    });

    useEffect(() => {
        if (isPrinting && !isGeneratingPreview) {
            printSlides();
        }

    }, [isPrinting, isGeneratingPreview]);

    return (
        <div>
            <div onClick={handlePrint} style={{ cursor: 'pointer', marginTop: '10px', marginLeft: '5px' }}>
                <img src={printIcon} width={22} alt="Print" />
            </div>
            <Modal
                title="Generating preview"
                visible={isGeneratingPreview}
                closable={false}
                footer={null}
                width={240}
                centered
                style={{ borderRadius: '8px', width: '150px' }}
            >
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <p style={{ marginBottom: '10px' }}>This may take a few moments</p>
                    <Spin
                        indicator={
                            <LoadingOutlined
                                style={{
                                    fontSize: 28,
                                    fontWeight: 'bold',
                                    color: 'black'
                                }}
                                spin
                            />
                        }
                    />
                </div>
            </Modal>
            {isPrinting &&
            <div id="print-slide-container" style={{ display: 'none' }}>
                <PrintContainer />
            </div>
            }
        </div>
    );
};

export default PrintSlide;